import { render } from "./ContentSection.vue?vue&type=template&id=61270936&scoped=true"
import script from "./ContentSection.vue?vue&type=script&lang=js"
export * from "./ContentSection.vue?vue&type=script&lang=js"

import "./ContentSection.vue?vue&type=style&index=0&id=61270936&scoped=true&lang=css"

import exportComponent from "/Users/wadayuki/Desktop/anone/anone/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61270936"]])

export default __exports__